export type SendGuardInput = {
  readonly threadId: string | undefined;
  readonly prompt: string;
  readonly hasImage: boolean;
  readonly isSending: boolean;
  readonly isAgentRunning: boolean;
  readonly isUploading: boolean;
  readonly approvalBusy: boolean;
};

export function canSendMessage(input: SendGuardInput): boolean {
  if (!input.threadId) return false;
  if (input.isSending || input.isAgentRunning || input.isUploading) return false;
  if (input.approvalBusy) return false;
  return input.prompt.trim().length > 0 || input.hasImage;
}
